import React from "react";
import SupplierLedger from "pages/Purchase/SupplierLedger";

const ConsultantLedger = () => {
  return <SupplierLedger type="Consultant" component="consultantLedger" />;
};

export default ConsultantLedger;
